import { makeStyles } from '@material-ui/core/styles';

export const useConversationMessagesStyles = makeStyles(theme => ({
  conversationContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    height: '100%',
    overflow: 'auto',
    padding: theme.spacing(2),
    width: '100%'
  }
}));
